import { render, staticRenderFns } from "./dialog-2faotpfromemail.vue?vue&type=template&id=f8e9433c&scoped=true&"
import script from "./dialog-2faotpfromemail.vue?vue&type=script&lang=js&"
export * from "./dialog-2faotpfromemail.vue?vue&type=script&lang=js&"
import style0 from "./dialog-2faotpfromemail.vue?vue&type=style&index=0&id=f8e9433c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e9433c",
  null
  
)

export default component.exports